import React from "react";
import "./PaintExcellenceSection.css";
import paintCans from "../assets/paint_cans.png";
import map from "../assets/map_pakistan.png";
import CheckIcon from "../assets/check.svg";
const technicalTests = [
  "Color consistency and retention",
  "Adhesion and durability",
  "Weather resistance",
  "Coverage efficiency",
  "Environmental safety standards",
];

const PaintExcellenceSection = () => {
  return (
    <div className="excellence-section">
      <div className="excellence-content-wrapper">
        {/* === Left Column: Technical Excellence === */}
        <div className="technical-excellence">
          <h2 className="section-title">Technical Excellence</h2>
          <p className="section-description">
            Every Glamur Paint product undergoes extensive testing for:
          </p>
          <ul className="test-list">
            {technicalTests.map((test, index) => (
              <li key={index} className="test-item">
                <img src={CheckIcon} alt="Check Icon" className="check-icon" />
                {test}
              </li>
            ))}
          </ul>
        </div>

        {/* === Right Column: Guidance and Availability === */}
        <div className="guidance-availability">
          {/* Product Selection Guidance Card */}
          <div className="info-card">
            <img
              src={paintCans}
              alt="Various paint cans and samples"
              className="card-image"
            />

            <h3 className="card-title">Product Selection Guidance</h3>
            <p className="card-text">
              Not sure which paint is right for your project? Our technical team
              provides free consultation services to help customers across
              Pakistan select the optimal paint products for their specific
              requirements, climate conditions, and budget considerations.
            </p>
          </div>

          {/* Available Nationwide Card */}
          <div className="info-card">
            <img src={map} alt="map of Pakistan" className="card-image" />

            <h3 className="card-title">Available Nationwide</h3>
            <p className="card-text">
              All Glamur Paint products are available through our extensive
              distribution network across Pakistan's major cities, with the
              strongest availability in Sindh Province for immediate delivery
              and support.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaintExcellenceSection;
